module.exports = __webpack_public_path__ + "static/media/logo-shopify.83a03dff.svg";